import { Field } from "formik";

const OtherFields = ({
  values,
  setFieldValue,
}: {
  values: any;
  setFieldValue: any;
}) => {
  return (
    <div className="card my-card">
      <div className="card-header my-card-header bg-lighter">
        <div>
          <h6 className="my-card-header-head">Other Details</h6>
        </div>
      </div>
      <div className="card-body my-card-body">
        <div className="row g-3 m-0">
          <div className="col-12 col-lg-8 col-lg-4">
            <Field
              type="checkbox"
              id="is_digital_signature"
              name="is_digital_signature"
              className="form-check-input me-2"
              checked={values.is_digital_signature}
              onChange={(e: any) => {
                setFieldValue(e.target.name, e.target.checked);
              }}
            />
            <label className="form-check-label">
              Invoice Digital Signature
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherFields;
